<template>
  <div class="registration_form">
    <el-form :model="query" ref="lefts" :rules="rules" label-width="120px">
      <el-row>
        <el-col :span="8">
          <el-form-item label="中文姓名" prop="name">
            <el-input :disabled="disabledNormal" v-model="query.name" placeholder="请输入中文姓名"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="民族" prop="nation" class="custom">
            <el-select
              :popper-append-to-body="false"
              :disabled="disabledNormal"
              v-model="query.nation"
              filterable
              placeholder="请选择民族"
            >
              <el-option
                v-for="(item,index) in nationList"
                :key="index"
                :label="item.label"
                :value="item.label"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="职务" prop="duties" class="custom">
            <el-input :disabled="isDisabled" placeholder="请输入职务" v-model="query.duties"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="出生年月" prop="birthday">
            <el-date-picker
              :disabled="disabledNormal"
              v-model="query.birthday"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="选择日期"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="性别" prop="gender" class="custom">
            <el-select
              :popper-append-to-body="false"
              :disabled="disabledNormal"
              v-model="query.gender"
              placeholder="请选择性别"
            >
              <el-option label="男" :value="1"></el-option>
              <el-option label="女" :value="0"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="职称" prop="professionalRanks" class="custom">
            <el-select
              :popper-append-to-body="false"
              :disabled="isDisabled"
              v-model="query.professionalRanks"
              placeholder="请选择职称"
            >
              <el-option label="初级职称" value="初级职称"></el-option>
              <el-option label="中级职称" value="中级职称"></el-option>
              <el-option label="副教授（高级教练）" value="副教授"></el-option>
              <el-option label="教授（国家级教练）" value="教授"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <template v-if="!disabledNormal">
            <el-form-item label class="rows">
              <el-form :model="query" label-width="120px">
                <el-form-item class="sel_cg">
                  <el-select
                    style="width:90px"
                    @change="selectCard"
                    :popper-append-to-body="false"
                    placeholder="身份证号"
                    v-model="query.idCardType"
                  >
                    <el-option label="身份证号" :value="1"></el-option>
                    <el-option label="港澳证号" :value="2"></el-option>
                    <el-option label="台湾证号" :value="3"></el-option>
                  </el-select>
                </el-form-item>
              </el-form>
              <el-form class="cards_box" :model="query" ref="cards">
                <el-form-item
                  label=" "
                  prop="idCard"
                  class="id_card"
                  :rules="[
        {required:true,validator:cardValidate,trigger:'blur'}]"
                >
                  <el-input :disabled="disabledNormal" v-model="query.idCard" placeholder="请输入证件号码"></el-input>
                </el-form-item>
              </el-form>
            </el-form-item>
          </template>
          <template v-else>
            <el-form-item
              label="身份证号"
              prop="idCard"
              :rules="[{required:true,message:'证件号码不能为空',trigger:'blur'}]"
            >
              <el-input disabled v-model="query.idCard" placeholder="请输入证件号码"></el-input>
            </el-form-item>
          </template>
        </el-col>
        <el-col :span="8">
          <el-form-item label="身高" prop="height" class="custom">
            <el-input :disabled="isDisabled" v-model="query.height" placeholder="请输入身高">
              <span class="unit" slot="suffix">cm</span>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="体重" prop="weight" class="custom">
            <el-input :disabled="isDisabled" placeholder="请输入体重" v-model="query.weight">
              <span class="unit" slot="suffix">kg</span>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="最后学历" prop="education">
            <el-select
              :popper-append-to-body="false"
              :disabled="isDisabled"
              v-model="query.education"
              placeholder="请选择学历"
            >
              <el-option label="大专" :value="1"></el-option>
              <el-option label="本科" :value="2"></el-option>
              <el-option label="研究生" :value="3"></el-option>
              <el-option label="其他" :value="4"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="手机" prop="phone" class="custom">
            <el-input :disabled="isDisabled" v-model="query.phone" placeholder="请输入手机号"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="邮箱" prop="email" class="custom">
            <el-input :disabled="isDisabled" placeholder="请输入邮箱" v-model="query.email"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <template v-for="(item,index) in query.projectJson">
        <el-row :key="index">
          <el-col :span="8">
            <el-form-item
              :label="'注册项目' + (index + 1)"
              :prop="'projectJson.' + index + '.projectNew'"
              :rules=" [{ required: true, message: '注册项目不能为空', trigger: 'change' }]"
            >
              <el-select
                @change="selectProject"
                placeholder="请选择项目"
                :popper-append-to-body="false"
                :disabled="operation?true:false"
                v-model="item.projectNew"
              >
                <el-option
                  v-for="(temp,num) in projectLists"
                  :key="num"
                  :disabled="temp.disabled"
                  :value="temp.value"
                  :label="temp.label"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="裁判等级"
              class="custom"
              :prop="'projectJson.' + index + '.refereeRank'"
              :rules=" [{ required: true, message: '裁判等级不能为空', trigger: 'change' }]"
            >
              <el-select :disabled="isDisabled" v-model="item.refereeRank" placeholder="请选择裁判等级">
                <el-option value="国际级" label="国际级"></el-option>
                <el-option value="国家级" label="国家级"></el-option>
                <el-option value="荣誉级" label="荣誉级"></el-option>
                <el-option value="一级" label="一级"></el-option>
                <el-option value="二级" label="二级"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="批准时间"
              class="custom"
              :prop="'projectJson.' + index + '.passDate'"
              :rules=" [{required: true,message:'批准时间不能为空',trigger: 'change'
          }]"
            >
              <el-date-picker
                :disabled="disabledNormal"
                v-model="item.passDate"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
      <el-row v-if="!operation">
        <el-col>
          <p style="display:flex;margin:0 0 20px 120px">
            <span
              @click="addProject"
              style="color:rgba(30, 99, 176);cursor:pointer;font-size:14px;margin:0 20px 0 0"
            >添加项目</span>
            <span
              v-if="query.projectJson.length > 1"
              @click="deleteProject"
              style="color:rgb(253, 102, 102);cursor:pointer;font-size:14px;"
            >删除项目</span>
          </p>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="主要执裁记录" prop="refereeRecord">
            <el-input
              :disabled="disabledNormal"
              v-model="query.refereeRecord"
              type="textarea"
              resize="none"
              :autosize="{ minRows: 4, maxRows: 10}"
              placeholder="请填写主要执裁记录，总数不超过3条。"
              maxlength="200"
              show-word-limit
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="通信地址" prop="address">
            <el-input
              :disabled="isDisabled"
              v-model="query.address"
              placeholder="请输入通信地址"
              maxlength="150"
              show-word-limit
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="工作单位">
            <el-input disabled v-model="query.schoolName" placeholder="自动识别"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="注册证号" class="custom">
            <el-input :value="query.registerNumber" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!-- <el-form
      :model="query"
      ref="lefts"
      style="margin:0 15px 42px 0;"
      :rules="rules"
      label-width="120px"
    >
      <el-form-item label="中文姓名" prop="name">
        <el-input :disabled="disabledNormal" v-model="query.name" placeholder="请输入中文姓名"></el-input>
      </el-form-item>
      <el-form-item label="出生年月" prop="birthday">
        <el-date-picker
          :disabled="disabledNormal"
          v-model="query.birthday"
          value-format="yyyy-MM-dd"
          type="date"
          placeholder="选择日期"
        ></el-date-picker>
      </el-form-item>
      <template v-if="!disabledNormal">
        <el-form-item label class="rows">
          <el-form :model="query" label-width="120px">
            <el-form-item class="sel_cg">
              <el-select
                style="width:90px"
                @change="selectCard"
                :popper-append-to-body="false"
                placeholder="身份证号"
                v-model="query.idCardType"
              >
                <el-option label="身份证号" :value="1"></el-option>
                <el-option label="港澳证号" :value="2"></el-option>
                <el-option label="台湾证号" :value="3"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <el-form class="cards_box" :model="query" ref="cards">
            <el-form-item
              label=" "
              prop="idCard"
              class="id_card"
              :rules="[
        {required:true,validator:cardValidate,trigger:'blur'}]"
            >
              <el-input :disabled="disabledNormal" v-model="query.idCard" placeholder="请输入证件号码"></el-input>
            </el-form-item>
          </el-form>
        </el-form-item>
      </template>
      <template v-else>
        <el-form-item
          label="身份证号"
          prop="idCard"
          :rules="[{required:true,message:'证件号码不能为空',trigger:'blur'}]"
        >
          <el-input disabled v-model="query.idCard" placeholder="请输入证件号码"></el-input>
        </el-form-item>
      </template>
      <el-form-item label="最后学历" prop="education">
        <el-select
          :popper-append-to-body="false"
          :disabled="isDisabled"
          v-model="query.education"
          placeholder="请选择学历"
        >
          <el-option label="大专" :value="1"></el-option>
          <el-option label="本科" :value="2"></el-option>
          <el-option label="研究生" :value="3"></el-option>
          <el-option label="其他" :value="4"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="注册项目1" prop="projectFirst">
        <el-select
          placeholder="请选择项目"
          :popper-append-to-body="false"
          :disabled="disabledNormal"
          v-model="query.projectFirst"
        >
          <el-option
            v-for="(temp,num) in projectList"
            :key="num"
            :disabled="temp.disabled"
            :value="temp.value"
            :label="temp.label"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <el-form
      :model="query"
      ref="middle"
      style="margin:0 15px 42px 0;"
      :rules="rules"
      label-width="80px"
    >
      <el-form-item label="民族" prop="nation">
        <el-select
          :popper-append-to-body="false"
          :disabled="disabledNormal"
          v-model="query.nation"
          filterable
          placeholder="请选择民族"
        >
          <el-option
            v-for="(item,index) in nationList"
            :key="index"
            :label="item.label"
            :value="item.label"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="性别" prop="gender">
        <el-select
          :popper-append-to-body="false"
          :disabled="disabledNormal"
          v-model="query.gender"
          placeholder="请选择性别"
        >
          <el-option label="男" :value="1"></el-option>
          <el-option label="女" :value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="身高" prop="height">
        <el-input :disabled="isDisabled" v-model="query.height" placeholder="请输入身高">
          <span class="unit" slot="suffix">cm</span>
        </el-input>
      </el-form-item>
      <el-form-item label="手机" prop="phone">
        <el-input :disabled="isDisabled" v-model="query.phone" placeholder="请输入手机号"></el-input>
      </el-form-item>
      <el-form-item label="裁判等级" prop="refereeRank">
        <el-select v-model="query.refereeRank" placeholder="请选择裁判等级">
          <el-option value="国际级" label="国际级"></el-option>
          <el-option value="国家级" label="国家级"></el-option>
          <el-option value="荣誉级" label="荣誉级"></el-option>
          <el-option value="一级" label="一级"></el-option>
          <el-option value="二级" label="二级"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <el-form
      :model="query"
      ref="rights"
      style="margin:0 15px 42px 0;"
      :rules="rules"
      label-width="80px"
    >
      <el-form-item label="职务" prop="duties">
        <el-input :disabled="isDisabled" placeholder="请输入职务" v-model="query.duties"></el-input>
      </el-form-item>
      <el-form-item label="职称" prop="professionalRanks">
        <el-select
          :popper-append-to-body="false"
          :disabled="isDisabled"
          v-model="query.professionalRanks"
          placeholder="请选择职称"
        >
          <el-option label="初级职称" value="初级职称"></el-option>
          <el-option label="中级职称" value="中级职称"></el-option>
          <el-option label="副教授（高级教练）" value="副教授"></el-option>
          <el-option label="教授（国家级教练）" value="教授"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="体重" prop="weight">
        <el-input :disabled="isDisabled" placeholder="请输入体重" v-model="query.weight">
          <span class="unit" slot="suffix">kg</span>
        </el-input>
      </el-form-item>
      <el-form-item label="邮箱" prop="email">
        <el-input :disabled="isDisabled" placeholder="请输入邮箱" v-model="query.email"></el-input>
      </el-form-item>
      <el-form-item label="批准时间" prop="passDate">
        <el-date-picker
          :disabled="disabledNormal"
          v-model="query.passDate"
          value-format="yyyy-MM-dd"
          type="date"
          placeholder="选择日期"
        ></el-date-picker>
      </el-form-item>
    </el-form>
    <el-form
      ref="bottoms"
      style="position:absolute;bottom:20px;left:0;width:calc(100% - 350px)"
      :model="query"
      :rules="rules"
      label-width="120px"
    >
      <el-form-item label="主要执裁记录" prop="refereeRecord">
        <el-input
          :disabled="disabledNormal"
          v-model="query.refereeRecord"
          type="textarea"
          resize="none"
          :autosize="{ minRows: 4, maxRows: 10}"
          placeholder="请填写主要执裁记录，总数不超过3条。"
        ></el-input>
      </el-form-item>
      <el-form-item class="form_rows" label>
        <el-form
          style="margin:0 15px 0 0;width:38.5%"
          :model="query"
          :rules="rules"
          label-width="120px"
        >
          <el-form-item label="工作单位">
            <el-input disabled v-model="query.schoolName" placeholder="自动识别"></el-input>
          </el-form-item>
        </el-form>
        <el-form
          ref="address"
          style="margin:0 15px 0 0;width:32%"
          :model="query"
          :rules="rules"
          label-width="80px"
        >
          <el-form-item label="通信地址" prop="address">
            <el-input :disabled="isDisabled" v-model="query.address" placeholder="请输入通信地址"></el-input>
          </el-form-item>
        </el-form>
        <el-form
          ref="registerNumber"
          style="width:34%"
          :model="query"
          :rules="rules"
          label-width="80px"
        >
          <el-form-item label="注册证号">
            <el-input value disabled></el-input>
          </el-form-item>
        </el-form>
      </el-form-item>
    </el-form>-->
    <div class="user_img">
      <div class="empty">
        <img v-if="headImage " style="width:100%;height:100%" :src="headImage " alt />
        <template v-else>
          <i class="el-icon-user-solid" font-size="40px"></i>
          <p>2寸近照</p>
        </template>
      </div>
      <el-upload
        :style="{visibility:!isDisabled?'visible':'hidden'}"
        class="upload-demo"
        accept="image/jpeg, image/jpg, image/png"
        action="//up-z1.qiniup.com"
        :show-file-list="false"
        :before-upload="handleBefore"
        :on-success="uploadSuccess"
        :data="{token: uptoken}"
      >
        <el-button
          :loading="loading"
          style="color:#1E63B0;border-color:#1E63B0;margin-top:20px"
        >上传照片</el-button>
      </el-upload>
    </div>
    <el-dialog
      width="500px"
      title="操作提示"
      center
      :close-on-click-modal="false"
      :visible.sync="tipDialogVisible"
      append-to-body
      :modal-append-to-body="false"
    >
      <div class="modal_content">
        <i class="el-icon-warning"></i>
        <section>
          <p>无法完成操作！</p>
          <p>照片大小请限制在 1 MB以内。</p>
        </section>
      </div>
      <div class="footer_modal">
        <el-button style="width:90px" type="primary" @click="closeTips">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getSession } from "@/utils/storage.js";
import registerData from "@/assets/json/register.json";
import { rule } from "@/utils/utils";
export default {
  props: {
    uptoken: {
      type: String
    },
    formInfo: {
      type: Object
    },
    operation: {
      type: String
    }
  },
  watch: {
    formInfo(value) {
      if (value) {
        for (let item in value) {
          if (this.query.hasOwnProperty(item))
            this.$set(this.query, item, value[item]);
        }
        this.headImage = this.query.headImage;
      }
    }
  },
  data() {
    return {
      tipDialogVisible: false,
      headImage: "",
      loading: false,
      query: {
        projectJson: [
          {
            projectNew: "", //注册项目
            refereeRank: "", //裁判等级
            passDate: "", //批准时间
            refereeRankImage: ""
          }
        ],
        registerNumber: "",
        name: "",
        birthday: "",
        idCardType: 1,
        idCard: "",
        education: "",
        nation: "",
        gender: "",
        height: "",
        phone: "",
        duties: "",
        professionalRanks: "",
        weight: "",
        email: "",
        headImage: "",
        refereeRecord: "", // 主要执裁记录
        schoolName: JSON.parse(getSession("userInfo")).schoolName, //工作单位
        address: "" //通信地址
      },
      rules: {
        name: [{ required: true, validator: rule.name, trigger: "blur" }],
        birthday: [
          {
            type: "date",
            required: true,
            validator: rule.birthday,
            trigger: "change"
          }
        ],
        education: [
          { required: true, validator: rule.education, trigger: "change" }
        ],
        nation: [{ required: true, validator: rule.nation, trigger: "change" }],
        gender: [{ required: true, validator: rule.gender, trigger: "change" }],
        phone: [{ required: true, validator: rule.phone, trigger: "blur" }],
        email: [{ required: true, validator: rule.mustEmail, trigger: "blur" }],
        height: [{ validator: rule.notRequireHeight, trigger: "blur" }],
        weight: [{ validator: rule.notRequireWeight, trigger: "blur" }],
        refereeRecord: [
          { required: true, validator: rule.refereeRecord, trigger: "blur" }
        ],
        address: [{ required: true, validator: rule.address, trigger: "blur" }]
      },
      projectLists: []
    };
  },
  computed: {
    // 根据证件类型切换证件号验证规则
    cardValidate() {
      return (rule, value, cb) => {
        if (!value) {
          return cb(new Error("证件号不能为空"));
        }
        if (
          this.query.idCardType === 1 &&
          !/^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/.test(
            value
          )
        ) {
          return cb(new Error("证件号格式错误"));
        }
        if (this.query.idCardType === 2 && !/^[0-9a-zA-Z]{9}$/.test(value)) {
          return cb(new Error("证件号格式错误!"));
        }
        if (this.query.idCardType === 3 && !/^[0-9a-zA-Z]{8}$/.test(value)) {
          return cb(new Error("证件号格式错误!"));
        }
        cb();
      };
    },
    // 草稿可修改项
    disabledNormal() {
      if (this.operation === "watch") return true;
      if (this.formInfo && this.formInfo.name) {
        if (this.formInfo.state === 0) {
          return false;
        } else {
          return true;
        }
      }
      return false;
    },
    // 判断是否禁用表单组件输入
    isDisabled() {
      return this.operation === "watch" ? true : false;
    },
    // 民族列表
    nationList() {
      return registerData.nationList;
    }
  },
  methods: {
    // 项目列表
    projectList() {
      this.projectLists = [];
      registerData.judgeProjectList.filter(item => {
        this.projectLists.push({
          ...item,
          disabled: false
        });
      });
    },
    // 选择项目
    selectProject(value) {
      this.projectLists.filter((item, index) => {
        this.$set(this.projectLists[index], "disabled", false);
      });
      this.projectLists.filter((item, index) => {
        this.query.projectJson.filter(temp => {
          if (item.value === temp.projectNew) {
            this.$set(this.projectLists[index], "disabled", true);
          }
        });
      });
    },
    // 删除项目
    deleteProject() {
      const project = this.query.projectJson[this.query.projectJson.length - 1]
        .projectNew;
      this.projectLists.filter((item, index) => {
        if (item.value === project)
          this.$set(this.projectLists[index], "disabled", false);
      });
      this.query.projectJson.splice(this.query.projectJson.length - 1, 1);
      this.$emit("refereeRankImageOpeartion", this.query.projectJson);
    },
    // 添加项目
    addProject() {
      this.query.projectJson.push({
        projectNew: "", //注册项目
        refereeRank: "", //裁判等级
        passDate: "", //批准时间
        refereeRankImage: ""
      });
      this.$emit("refereeRankImageOpeartion", this.query.projectJson);
    },
    // 表单提交验证
    submits() {
      if (this.$refs["cards"]) {
        return Promise.all([
          this.$refs["lefts"].validate(),
          this.$refs["cards"].validate()
          // this.$refs["middle"].validate(),
          // this.$refs["rights"].validate(),
          // this.$refs["bottoms"].validate(),
          // this.$refs["address"].validate()
        ])
          .then(res => {
            if (!this.query.headImage) {
              this.$message.warning("请上传2寸照片");
              return null;
            }
            return Promise.resolve(this.query);
          })
          .catch(err => {
            this.$message.warning("请完善裁判员信息");
            return null;
          });
      } else {
        return Promise.all([this.$refs["lefts"].validate()])
          .then(res => {
            if (!this.query.headImage) {
              this.$message.warning("请上传2寸照片");
              return null;
            }
            return Promise.resolve(this.query);
          })
          .catch(err => {
            this.$message.warning("请完善裁判员信息");
            return null;
          });
      }
    },
    // 重置表单
    resetForm() {
      this.$refs["lefts"].resetFields();
      this.$refs["cards"].validate();
    },
    // 选择证件类型
    selectCard(value) {
      this.query.idCard = "";
      let _field = this.$refs["cards"].fields; /*当然，你可以打印一下fields*/
      _field.map(i => {
        if (i.prop === "idCard") {
          //通过prop属性值相同来判断是哪个输入框，比如：要移除prop为'user'
          i.resetField();
          return false;
        }
      });
    },
    handleBefore(file) {
      this.files = file;
      this.loading = true;
      var testmsg = /^image\/(jpeg|png|jpg)$/.test(file.type);
      const isLt5M = file.size / 1024 / 1024 <= 1; //图片大小不超过2MB
      if (!testmsg) {
        this.$message.error("上传图片格式不对!");
        this.loading = false;
        return false;
      }
      if (!isLt5M) {
        // this.$message.error("上传图片大小不能超过 5M!");
        this.tipDialogVisible = true;
        this.loading = false;
        return false;
      }
      return testmsg && isLt5M;
    },
    // 上传成功
    uploadSuccess(response, file, fileList) {
      this.loading = false;
      this.$message.success("上传成功！");
      this.query.headImage = response.key;
      this.headImage = window.URL.createObjectURL(this.files);
    },
    // 关闭图片上传限制弹窗
    closeTips() {
      this.tipDialogVisible = false;
    }
  },
  mounted() {
    this.projectList();
  }
};
</script>
<style lang="less" scoped>
@media (min-width: 1920px) {
  .registration_form {
    /deep/ .address {
      width: 92%;
    }
    /deep/ .rows {
      .el-select {
        width: 130px;
      }
      .cards_box {
        width: 100%;
      }
    }
  }
}
@media (min-width: 900px) and( max-width: 1919px) {
  .registration_form {
    /deep/ .address {
      width: 100%;
    }
    /deep/ .custom {
      & > .el-form-item__label {
        width: 100px !important;
      }
      & > .el-form-item__content {
        margin-left: 100px !important;
      }
    }
  }
}
.registration_form {
  position: relative;
  display: flex;
  padding: 40px 20px 40px 0;
  justify-content: space-between;
  /deep/ .form_rows {
    > .el-form-item__content {
      display: flex;
      justify-content: space-between;
      margin-left: 0px !important;
    }
  }
  /deep/ .rows {
    > .el-form-item__content {
      display: flex;
      margin-left: 20px !important;
    }
    .sel_cg {
      > .el-form-item__content {
        margin-left: 0 !important;
      }
    }
    .el-select {
      .el-input--suffix .el-input__inner {
        padding: 0 25px 0 5px;
      }
    }
  }
  /deep/ .id_card {
    margin-left: 10px;
    > .el-form-item__label {
      width: 10px !important;
      padding-right: 5px;
      position: absolute;
      left: -10px;
      top: 0;
    }
    > .el-form-item__content {
      margin-left: 0px !important;
    }
  }
  /deep/ .el-input,
  /deep/ .el-select {
    width: 100%;
  }
  /deep/ .el-input.is-disabled .el-input__inner {
    background-color: #fff;
    color: #606266;
  }
  /deep/ .el-textarea.is-disabled .el-textarea__inner {
    background-color: #fff;
    color: #606266;
  }
  .unit {
    color: #333;
    font-size: 14px;
    padding-right: 5px;
  }
  .user_img {
    margin-left: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .empty {
    width: 295px;
    height: 412px;
    background: #d8d8d8;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 40px;
    > p {
      margin-top: 10px;
      font-size: 14px;
    }
  }
}
</style>